<div
  class="app-header"
  tabindex="0"
  *ngIf="!isLoading && !(confirmDialog$ | async)"
  [ngClass]="{ 'not-landing': !isLandingPage }"
>
  <div class="container">
    <app-header-fallback class="app-header-fallback"></app-header-fallback>
  </div>
</div>
